import type { ReactNode } from 'react';
import { ModalDefaultsProvider } from '@immo/ui-kit';
import { useTranslations } from '@/i18n/use-translations';

export function ModalDefaults({ children }: { readonly children: ReactNode }) {
  const t = useTranslations('common.modal.confirm-close');
  const tModal = useTranslations('common.modal');

  return (
    <ModalDefaultsProvider
      confirmClose={{
        title: t('title'),
        description: t('description'),
        confirmLabel: t('confirm'),
        cancelLabel: t('cancel'),
      }}
      closeLabel={tModal('close')}
    >
      {children}
    </ModalDefaultsProvider>
  );
}
